<div>
    <app-pa-filtro [filtros]="filtros"> </app-pa-filtro>
    <app-pa-lista
      [filtros]="filtros"
      (definirFiltro)="definirFiltro()" 
      (exibir)="selecionar($event)"
    >
    </app-pa-lista>
  </div> 